'use client'

import dynamic from 'next/dynamic'

const RenderDebugOverlay = dynamic(
  () => import('./RenderDebugOverlay').then((m) => ({ default: m.RenderDebugOverlay })),
  { ssr: false }
)

export function DebugOverlayLoader() {
  if (process.env.NODE_ENV !== 'development') return null
  return <RenderDebugOverlay />
}
